import React, { useState } from 'react';
import './ArchitectRoleBadge.css';

export const ArchitectRoleBadge: React.FC<{ compact?: boolean }> = ({ compact = false }) => (
  <span className={`arb-badge${compact ? ' arb-badge--compact' : ''}`}>Architect</span>
);

export const DecisionForPill: React.FC<{ name: string }> = ({ name }) => {
  const [open, setOpen] = useState(false);
  return (
    <span
      className="arb-for"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      For {name}
      {open && (
        <span className="arb-for-pop" role="tooltip">
          They can see and reply to this. Working notes stay with the team.
        </span>
      )}
    </span>
  );
};

export const WorkingNotesPill: React.FC = () => (
  <span className="arb-notes">Working notes</span>
);

export const ThreadVisibilityBadge: React.FC<{ variant: 'architect' | 'internal' }> = ({ variant }) => (
  <span className={`arb-thread arb-thread--${variant}`}>
    {variant === 'architect'
      ? 'Architect discussion'
      : 'Working internal thread between LCTF staff, designers, and engineers'}
  </span>
);
